import React, { useState } from 'react';
import css from './ShippingPreferenceModal.module.css';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { useDispatch, useSelector } from 'react-redux';
import { currentUserSelector } from '../../ducks/user.duck';
import ShippingDetailsForm from '../../containers/ShippingDetailsPage/ShippingDetailsForm/ShippingDetailsForm';
import { useConfiguration } from '../../context/configurationContext';
import getCountryCodes from '../../translations/countryCodes';
import { createShippoAddress, selectShippoAddressStatus } from '../../ducks/shippo.duck';
import Modal from '../../components/Modal/Modal';
import { H3 } from '../Heading/Heading';
import { FormattedMessage } from 'react-intl';
import {
  getShippingPreference,
  getShippingDetails,
  getShippingDimenisions,
  getUserEmail,
  getUserFullName,
  getUserPhoneNumber,
} from '../../util/dataExtractor';
import { WeightUnitEnum } from '../../config/configExtras';
import { OWN, PLATFORM } from '../../util/constants';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

const ShippingPreferenceModal = () => {
  const dispatch = useDispatch();
  const config = useConfiguration();

  const currentUser = useSelector(currentUserSelector);
  const { saveShippoAddressInProgress, saveShippoAddressError, shippoAddressSaved } = useSelector(
    selectShippoAddressStatus
  );
  const hasPreferences = getShippingPreference(currentUser);

  const shippingAddress = getShippingDetails(currentUser);
  const shippingDimensions = getShippingDimenisions(currentUser);
  const [isModalOpen, setIsModalOpen] = useState(!hasPreferences);
  const countryCodes = getCountryCodes(config.localization.locale);
  const savedCountry = countryCodes.find(c => c.code === shippingAddress?.country);
  const currentUserName = getUserFullName(currentUser);
  const currentUserEmail = getUserEmail(currentUser);
  const currentUserPhoneNumber = getUserPhoneNumber(currentUser);
  const savedWeightUnit = WeightUnitEnum.find(c => c.value === shippingDimensions?.unit);
  const initialValues = {
    ...shippingAddress,
    country: savedCountry,
    weight: shippingDimensions?.weight,
    unit: savedWeightUnit,
    phone: currentUserPhoneNumber,
  };
  const handleSubmit = async values => {
    const preference = values?.shippingPreference || PLATFORM;
    if (preference === OWN) {
      await dispatch(
        updateProfile({
          publicData: { shippingPreference: OWN },
          protectedData: { shippingPreference: OWN },
        })
      );
      setIsModalOpen(false);
      return;
    }

    const shippingDetails = {
      ...values,
      shippingPreference: PLATFORM,
      email: currentUserEmail,
      name: currentUserName,
      currentUserId: currentUser?.id?.uuid,
      country: values?.country?.code,
      unit: values?.unit?.value,
    };

    await dispatch(createShippoAddress(shippingDetails));
    setIsModalOpen(false);
  };
  const handleClose = () => {
    setIsModalOpen(false);
  };
  if (hasPreferences) {
    return;
  }
  return (
    <Modal
      id="ShippingPreferenceModal"
      isOpen={isModalOpen}
      onClose={handleClose}
      onManageDisableScrolling={(componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling))
      }
      hideCloseButton
      usePortal
    >
      <div className={css.payoutContainer}>
        <H3 as="h3" className={css.modalTitle}>
          <FormattedMessage id="ShippingPreferenceModal.title" />
        </H3>
        <ShippingDetailsForm
          className={css.form}
          hideTitle
          initialValues={{
            ...initialValues,
            length: '8.5',
            width: '11',
            height: '1',
            shippingPreference: hasPreferences || PLATFORM,
          }}
          currentUser={currentUser}
          onSubmit={handleSubmit}
          inProgress={saveShippoAddressInProgress}
          ready={shippoAddressSaved}
          updateProfileError={saveShippoAddressError}
        />
      </div>
    </Modal>
  );
};

export default ShippingPreferenceModal;
